<template>
  <div class="h-full p-20px">
    <div class="h-full  flex flex-column">
      <Tabs :datas="{'deptSummary':'按使用部门汇总','typeSummary':'按资产类别汇总'}" class="px-20px bg-white-color" v-model="tab"/>
      <vxe-toolbar class-name="px-8px" :loading="loading">
        <template #buttons>
          <div class="h-input-group h-input-group-auto">
            <span class="h-input-addon">期间：</span>
            <Select v-model="params.start" :datas="checkDataList" class="!w-120px" :deletable="false"/>
            <!-- <span class="h-input-addon">至</span>
            <Select v-model="params.end" :datas="checkDataList" class="!w-120px" :deletable="false"/> -->
            <Button :loading="loading" @click="loadList" color="primary" icon="h-icon-search">查询</Button>
          </div>
        </template>
        <template #tools>

        </template>
      </vxe-toolbar>
      <div class="flex-1">
        <vxe-table ref="xTable" height="auto" :loading="loading" :data="dataList">
          <vxe-column v-if="tab == 'deptSummary'" title="使用部门" field="deptName" width="300">
            <template #default="{ row }">
              {{ getDeptName(row.deptId) }}
            </template>
          </vxe-column>
          <vxe-column v-if="tab == 'typeSummary'" title="资产类别" field="deptId" width="300"/>
          <vxe-column title="资产原值" field="originalValue" formatter="toMoney" width="220"/>
          <vxe-column title="本期折旧" field="current" formatter="toMoney" width="120"/>
          <vxe-column title="本年累计折旧" field="currentYear" formatter="toMoney" width="120"/>
          <vxe-column title="累计折旧" field="total" formatter="toMoney" width="120"/>
          <vxe-column title="减值准备" field="" width="120"/>
          <vxe-column title="资产净值" field="netValue" align="right" formatter="toMoney" width="120"/>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "AssetsSummary",
}
</script>

<script setup>

import {reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import manba from "manba";
import Assets from "@/api/Assets";
import setting from "@/api/setting";

const store = useStore();
const tab = ref('deptSummary');
const loading = ref(false);
const dataList = ref([])
const checkDataList = ref([])
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate).startOf(manba.MONTH).format();
const deptList = ref([])

const params = reactive({
  start: currentAccountDate,
  end: currentAccountDate,
  type: null,
})
Assets.checkDate().then(({data}) => {
  params.start = data[0].key;
  params.end = data[0].key;
  checkDataList.value = data;
  loadList();
})

const getDeptName = (deptId) =>{
  console.log(deptId)
  if(deptId){
    let name = deptList.value.find(item => item.key === deptId).title;
    return name ? name : '';
  }
  return '';
}

setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT']).then(({data}) => {
  deptList.value = data['DEPARTMENT'].map(val => {
    return {
      key: val.id,
      accountingCategoryId: val.accountingCategoryId,
      title: val.name
    }
  });
})

const merged = (data,type) => {
  // 使用reduce方法来合并具有相同deptId的对象  
  let mergedData = data.reduce((acc, curr) => {  
      let deptId = type == 'deptSummary' ? curr.deptId : curr.typeName;  
        
      // 如果累加器中还没有这个deptId的条目，则添加它  
      if (!acc[deptId]) {  
          acc[deptId] = {  
              deptId,  
              current: curr.current,  
              currentYear: curr.currentYear,  
              depreciationCredit: curr.depreciationCredit,  
              netValue: curr.netValue, // 注意：如果多个对象有相同的deptId，你可能需要决定如何处理netValue的合并  
              originalValue: curr.originalValue, // 通常不会相加，但这里保留第一个值作为示例  
              total: curr.total  
          };  
      } else {  
          // 如果已经存在，则累加数值字段  
          acc[deptId].current += curr.current;  
          acc[deptId].currentYear += curr.currentYear;  
          acc[deptId].depreciationCredit += curr.depreciationCredit;  
          acc[deptId].netValue += curr.netValue; // 注意：这取决于你如何想要合并netValue  
          acc[deptId].originalValue += curr.originalValue;
          acc[deptId].total += curr.total;  
      }  
        
      return acc;  
  }, {});  
    
  // 转换回数组（如果需要的话）  
  const mergedDataArray = Object.values(mergedData);  
  console.log(mergedDataArray)
  dataList.value = mergedDataArray;
}

const loadList = () => {
  dataList.value = [];
  loading.value = true;
  //jxd弃用这个接口
  // Assets.summary(Object.assign({}, params, {type: tab.value})).then(({data}) => {
  //   dataList.value = data;
  // }).finally(() => loading.value = false)
  params.end = params.start;
  Assets.Depreciation.detail(Object.assign({}, { page: 1, pageSize: 1000000 }, params))
  .then(({data: {rows, recordCount}}) => {
    if (rows && rows.length) {
      rows.forEach(row => {
        row['netValue'] = row.originalValue - row.total;
      })
    }
    // dataList.value = rows;
    console.log(rows)
    merged(rows,tab.value)
  }).finally(() => loading.value = false)
}
// loadList();

watch(tab, loadList);
</script>
